<script>
import {
  mapActions,
  mapGetters
} from 'vuex'

import {
  ReqOps,
  ReqState
} from '@/utils/vars'

export default {
  computed: {
    ...mapGetters([
      'api_key',
      'dark_theme',
      'req_state',
      'user',
      'user_abbr',
      'user_joined_str'
    ]),
    is_deleting_account() {
      return this.req_state[ReqOps.DeleteAccount] === ReqState.Request
    },
    is_loading_api_key() {
      return this.req_state[ReqOps.APIKey] === ReqState.Request
    }
  },
  data() {
    return {
      delete_dialog_is_open: false,
      local_api_key: null,
      theme: false
    }
  },
  methods: {
    ...mapActions([
      'delete_account',
      'load_api_key',
      'set_dark_theme'
    ]),
    on_delete_account_click() {
      this.delete_dialog_is_open = true
    },
    on_get_api_key_click() {
      this.load_api_key()
        .then(() => {
          this.local_api_key = this.api_key
        })
        .catch(() => {

        })
    }
  },
  mounted() {
    this.local_api_key = null
    this.theme = this.dark_theme
  },
  name: 'candela-theme-panel',
  watch: {
    theme(v, old) {
      this.set_dark_theme(v)
    }
  }
}
</script>

<template>
<div class='d-flex flex-column pa-4'>
  <div class='d-flex flex-column'>
    <div class='title mb-2'>Account</div>
    <div class='d-flex align-center'>
      <v-avatar color='primary' size='96'>
        <img v-if='user && user.avatar' :src='user.avatar'/>
        <div v-if='user && !user.avatar' class='display-1'>{{user_abbr}}</div>
      </v-avatar>
      <div class='d-flex flex-column ml-4'>
        <div class='display-1'>{{user.username}}</div>
        <div class='body-1'>Member Since: {{user_joined_str}}</div>
      </div>
    </div>
    <div class='d-flex justify-end'>
      <v-btn @click='on_delete_account_click'
        color='red' text small>
        <v-icon left x-small>fa-trash</v-icon>
        <span>Delete my Account</span>
      </v-btn>
    </div>
  </div>
  <v-divider class='my-8'/>
  <div>
    <div class='title mb-2'>Your API Key</div>
    <v-btn v-if='!local_api_key' @click='on_get_api_key_click'
      :loading='is_loading_api_key'
      class='mt-2' color='primaryi' outlined>
      Get My API Key
    </v-btn>
    <div v-if='local_api_key'>
      <code class='api-key pa-2 mb-4'>{{local_api_key}}</code>
      <div class='d-flex'>
        <v-icon class='mr-4' color='warning' x-large>fa-exclamation-triangle</v-icon>
        <div class='warning--text font-weight-bold'>
          Please Note: This API Key is considered sensitive data. Anyone with access to this key can modify the behavior of your Candela apps. Therefore, do not share it unless you want to provide someone else control over your apps. Do not include this API key in your version control systems.
        </div>
      </div>
      <div class='d-flex justify-end'>
        <v-btn @click='local_api_key=null' class='mt-2' color='primary' text>
          <span>Hide</span>
        </v-btn>
      </div>
    </div>
  </div>
  <v-divider class='my-8'/>
  <div>
    <div class='title mb-2'>Candela Settings</div>
    <div class='d-flex'>
      <div class='d-flex align-center'>
        <v-icon class='mr-2' small>fa-adjust</v-icon>
        <div class='mr-2'>Night Mode</div>
      </div>
      <v-switch v-model='theme' class='ma-0' color="secondary" hide-details/>
    </div>
  </div>
  <v-dialog v-model='delete_dialog_is_open' width='500'>
    <v-card>
      <v-card-title class='headline red'>
        Delete Account
      </v-card-title>
      <v-card-text class='body-1 mt-4'>
        By deleting your account, all of your apps and all data associated with them will also be deleted. Your API key will be revoked and all currently connected clients will be disconnected from the Candela service.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class='d-flex justify-space-between'>
        <v-btn @click='delete_dialog_is_open = false' color='primary' text>
          <span>Cancel</span>
        </v-btn>
        <v-btn @click='delete_account' :loading='is_deleting_account'
          color='red' text>
          <span>Please Delete My Account</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<style lang='sass' scoped>
.v-application code:before
  content: ""

.api-key
  font-size: 1.1em
  overflow-wrap: anywhere

</style>
